export class InputErrorModel<T> {
    field: keyof T;
    message?: string;
    index?: number;
    constructor(data?: Partial<InputErrorModel<T>>) {
        this.field = data?.field || ('' as keyof T);
        this.message = data?.message;
        this.index = data?.index;
    }
}
